import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

import { ReactComponent as IconTeamwork } from '../../../images/icons/icon-product-overview-teamwork.svg';
import { INTERNAL_LINKS } from '../../../utils';
import { InfoText } from '../../global/InfoText';

const Wrapper = styled.div`
  width: 100%;

  .info-text {
    position: absolute;
    bottom: 60px;
    right: 20px;
    max-width: 310px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    flex-direction: column;
    gap: 40px;

    .info-text {
      position: static;
      max-width: none;
      bottom: auto;
      right: auto;
    }
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.mediaQuery.EXTRA_LARGE}) {
    transform: translateX(-100px);
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    transform: translateX(0);
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    img,
    [data-gatsby-image-wrapper] {
      width: 100%;
    }
  }
`;

const path = '../../../../static/images/home/product-overview';

const INFO = {
  title: 'Teamwork, that works for teams',
  icon: <IconTeamwork />,
  description:
    'Get feedback from peers, align with stakeholders, review diff views, endorse trusted data, and build from reusable components — all in the same place.',
  cta: {
    text: 'Explore collaboration',
    link: INTERNAL_LINKS.ForTeams
  }
};

export function TeamworkImage() {
  return (
    <StaticImage
      alt="Teamwork"
      sizes="(min-width: 1240px) 1000px, 100vw"
      src={`${path}/team-work@2x.png`}
      width={977}
    />
  );
}

export const TeamWork: React.ComponentType = React.memo(() => {
  return (
    <Wrapper>
      <InfoText
        ctaText={INFO.cta.text}
        description={INFO.description}
        icon={INFO.icon}
        link={INFO.cta.link}
        title={INFO.title}
      />
      <Content>
        <TeamworkImage />
      </Content>
    </Wrapper>
  );
});
